// extracted by mini-css-extract-plugin
module.exports = {"label":"_1-Nzq","withLabelAttributes":"pwGZi","inputWrapper":"_-18XN"};